// authConfig.js
export const authFields = {
    login: [
      {
        name: "username",
        placeholder: "Введите имя пользователя",
        required: true,
        type: "text",
        label: "Имя пользователя",
        errorMessage: "Пожалуйста, введите корректное имя пользователя",
      },
      {
        name: "password",
        placeholder: "Введите пароль",
        required: true,
        type: "password",
        label: "Пароль",
        errorMessage: "Пожалуйста, введите пароль",
      },
    ],
    register: [
      {
        name: "username",
        placeholder: "Введите имя пользователя",
        required: true,
        type: "text",
        label: "Имя пользователя",
        errorMessage: "Пожалуйста, введите корректное имя пользователя",
      },
      {
        name: "password",
        placeholder: "Введите пароль",
        required: true,
        type: "password",
        label: "Пароль",
        errorMessage: "Пожалуйста, введите пароль",
      },
      {
        name: "confirmPassword",
        placeholder: "Подтвердите пароль",
        required: true,
        type: "password",
        label: "Подвтеврждение пароля",
        errorMessage: "Пароли не совпадают",
      },
    ],
  };
  